import QdtComponents from 'qdt-components'
import { testing, testingAppId } from '../testing.config'

export default ({ app }, inject) => {
  const host = app.$host

  const appId = testing ? testingAppId : '552cabdc-35f9-4f90-8e91-356b0bc222d1'

  const config = {
    host,
    prefix: '',
    port: 443, // window.location.port,
    secure: true,
    appId,
  }
  const connections = {
    vizApi: true,
    engineApi: true,
  }

  const qdtComponents = new QdtComponents(config, connections)

  inject('qdt', qdtComponents)
}
